import { Modal, Box, Slider } from "@mui/material";
import React, { useState, useEffect } from "react";
import Styles from "./FilterModal.module.css";
import { Close } from "@mui/icons-material";
import DateInput from "../../../commons/Inputs/DateInput/DateInput";
import TimeInput from "../../../commons/Inputs/TimeInput/TimeInput";
import { parseDateTimeFlexible } from "../../Modals/Banking/AddListing/helpers";
import TextInput from "../../../commons/Inputs/TextInput/TextInput";
import { useSelector } from "react-redux";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";

const FilterModal = ({ open, handleClose, onApplyFilters, currentFilters }) => {
  const today = new Date();
  const publicData = useSelector((state) => state?.publicSlice);
  const [injectionModals, setInjectionModals] = useState([
    [
      {
        startTime: "",
        endTime: "",
        startDate: "",
        endDate: "",
        quantity: "",
        rtcChecked: false,
      },
    ],
  ]);
  const [drawalModals, setDrawalModals] = useState([
    [
      {
        startTime: "",
        endTime: "",
        startDate: "",
        endDate: "",
        quantity: "",
        rtcChecked: false,
      },
    ],
  ]);
  const [errors, setErrors] = useState({});

  const [quantityRange, setQuantityRange] = useState([0, 10000]);
  const [settlementRateRange, setSettlementRateRange] = useState([-9, 9]);
  const [bankingFactorRange, setBankingFactorRange] = useState([100, 200]);
  const [selectedCreditRating, setSelectedCreditRating] = useState("");
  const [formData, setFormData] = useState({ rating: "" });

  const handleQuantityRangeChange = (event, newValue) => {
    setQuantityRange(newValue);
  };

  const handleSettlementRateRangeChange = (event, newValue) => {
    setSettlementRateRange(newValue);
  };

  const handleBankingFactorRangeChange = (event, newValue) => {
    setBankingFactorRange(newValue);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "rating") {
      setSelectedCreditRating(value);
    }
  };

  const handleCreditRatingChange = (value) => {
    const uppercaseValue = value.toUpperCase();
    let filteredValue = uppercaseValue.replace(/[^A-Z0-9+-]/g, "");
    filteredValue = filteredValue.replace(/[+-](?=.)/g, "");
    const match = filteredValue.match(/^([A-Z0-9]+)([+-]?)$/);
    if (match) {
      filteredValue = match[1] + (match[2] || "");
    }
    setSelectedCreditRating(filteredValue);
  };

  const resetFilters = () => {
    setQuantityRange([0, 10000]);
    setSettlementRateRange([-9, 9]);
    setBankingFactorRange([100, 200]);
    setSelectedCreditRating("");
    setFormData({ rating: "" });
    setInjectionModals([
      [
        {
          startTime: "",
          endTime: "",
          startDate: "",
          endDate: "",
          quantity: "",
          rtcChecked: false,
        },
      ],
    ]);
    setDrawalModals([
      [
        {
          startTime: "",
          endTime: "",
          startDate: "",
          endDate: "",
          quantity: "",
          rtcChecked: false,
        },
      ],
    ]);

    if (onApplyFilters) {
      onApplyFilters(null);
    }

    handleClose();
  };

  useEffect(() => {
    if (open && currentFilters) {
      if (currentFilters.quantityRange) {
        setQuantityRange(currentFilters.quantityRange);
      }
      if (currentFilters.settlementRateRange) {
        setSettlementRateRange(currentFilters.settlementRateRange);
      }
      if (currentFilters.bankingFactorRange) {
        setBankingFactorRange(currentFilters.bankingFactorRange);
      }
      if (currentFilters.selectedCreditRating) {
        setSelectedCreditRating(currentFilters.selectedCreditRating);
        setFormData((prev) => ({
          ...prev,
          rating: currentFilters.selectedCreditRating,
        }));
      }
      if (currentFilters.injectionModals) {
        setInjectionModals(currentFilters.injectionModals);
      }
      if (currentFilters.drawalModals) {
        setDrawalModals(currentFilters.drawalModals);
      }
    } else if (open && !currentFilters) {
      setQuantityRange([0, 10000]);
      setSettlementRateRange([-9, 9]);
      setBankingFactorRange([100, 200]);
      setSelectedCreditRating("");
      setFormData((prev) => ({ ...prev, rating: "" }));
      setInjectionModals([
        [
          {
            startTime: "",
            endTime: "",
            startDate: "",
            endDate: "",
            quantity: "",
            rtcChecked: false,
          },
        ],
      ]);
      setDrawalModals([
        [
          {
            startTime: "",
            endTime: "",
            startDate: "",
            endDate: "",
            quantity: "",
            rtcChecked: false,
          },
        ],
      ]);
    }
  }, [open, currentFilters]);

  const applyFilters = () => {
    const filterData = {
      quantityRange,
      settlementRateRange,
      bankingFactorRange,
      selectedCreditRating,
      injectionModals,
      drawalModals,
    };

    if (onApplyFilters) {
      onApplyFilters(filterData);
    }

    handleClose();
  };

  const handleInjectionChange = (modalIndex, rowIndex, field, value) => {
    if (field === "quantity") {
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (!newErrors.injectionModals) newErrors.injectionModals = [];
          if (!newErrors.injectionModals[modalIndex])
            newErrors.injectionModals[modalIndex] = [];
          if (!newErrors.injectionModals[modalIndex][rowIndex])
            newErrors.injectionModals[modalIndex][rowIndex] = {};
          newErrors.injectionModals[modalIndex][rowIndex][field] =
            "Quantity must be below 10,000";
          return newErrors;
        });
        return;
      } else {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors.injectionModals?.[modalIndex]?.[rowIndex]) {
            delete newErrors.injectionModals[modalIndex][rowIndex][field];
            if (
              Object.keys(newErrors.injectionModals[modalIndex][rowIndex])
                .length === 0
            ) {
              newErrors.injectionModals[modalIndex].splice(rowIndex, 1);
            }
            if (newErrors.injectionModals[modalIndex].length === 0) {
              newErrors.injectionModals.splice(modalIndex, 1);
            }
          }
          return newErrors;
        });
      }
    }
    setInjectionModals((prev) => {
      const currentRow = prev[modalIndex][rowIndex];
      const updatedRow = { ...currentRow, [field]: value };
      return prev.map((modalRows, idx) =>
        idx === modalIndex
          ? modalRows.map((r, rIdx) => (rIdx === rowIndex ? updatedRow : r))
          : modalRows,
      );
    });
  };

  const handleDrawalChange = (modalIndex, rowIndex, field, value) => {
    if (field === "quantity") {
      const numericValue = Number(value);
      if (numericValue < 0 || numericValue > 10000) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (!newErrors.drawalModals) newErrors.drawalModals = [];
          if (!newErrors.drawalModals[modalIndex])
            newErrors.drawalModals[modalIndex] = [];
          if (!newErrors.drawalModals[modalIndex][rowIndex])
            newErrors.drawalModals[modalIndex][rowIndex] = {};
          newErrors.drawalModals[modalIndex][rowIndex][field] =
            "Quantity must be below 10,000";
          return newErrors;
        });
        return;
      } else {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          if (newErrors.drawalModals?.[modalIndex]?.[rowIndex]) {
            delete newErrors.drawalModals[modalIndex][rowIndex][field];
            if (
              Object.keys(newErrors.drawalModals[modalIndex][rowIndex])
                .length === 0
            ) {
              newErrors.drawalModals[modalIndex].splice(rowIndex, 1);
            }
            if (newErrors.drawalModals[modalIndex].length === 0) {
              newErrors.drawalModals.splice(modalIndex, 1);
            }
          }
          return newErrors;
        });
      }
    }
    setDrawalModals((prev) => {
      const currentRow = prev[modalIndex][rowIndex];
      const updatedRow = { ...currentRow, [field]: value };
      return prev.map((modalRows, idx) =>
        idx === modalIndex
          ? modalRows.map((r, rIdx) => (rIdx === rowIndex ? updatedRow : r))
          : modalRows,
      );
    });
  };

  const minTimeForStartTime = (row) => {
    if (!row.startDate) return undefined;
    const startDateOnly = new Date(row.startDate);
    startDateOnly.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (+startDateOnly === +today) {
      const dt = new Date(new Date().getTime() + 3 * 60 * 60 * 1000);
      const h = String(dt.getHours()).padStart(2, "0");
      const m = String(dt.getMinutes()).padStart(2, "0");
      return `${h}:${m}`;
    }
    return undefined;
  };
  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) => handleChange(field, value)}
      list={list}
      value={formData[field]}
      example={example}
      heading={`${heading} *`}
      height="45px"
      error={errors[field]}
    />
  );

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        // slotProps={{
        //   backdrop: {
        //     style: {
        //       overflow: "hidden",
        //     },
        //   },
        // }}
      >
        <div className={`popupModal ${Styles.createEditModalCont}`} style={{ overflow: 'visible', position: 'relative' }}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">Filter</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div
            className={`scroll_bar_y display_flex_column_gap_8 ${Styles.bankingInputMainContainer}`}
          >
            {injectionModals.map((rows, modalIndex) => (
              <div
                key={modalIndex}
                className={`display_flex_column_gap_8 ${Styles.injectDrawalCont}`}
                style={{ position: "relative" }}
              >
                <div className={Styles.draInHeader}>
                  Injection
                  {injectionModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                </div>

                <div className={Styles.rowsScrollableContainer}>
                  {rows.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                    >
                      <DateInput
                        heading="Start Date"
                        value={row.startDate}
                        minDate={today}
                        onChange={(date) =>
                          handleInjectionChange(
                            modalIndex,
                            rowIndex,
                            "startDate",
                            date,
                          )
                        }
                        maxDate={
                          row.endDate ? new Date(row.endDate) : undefined
                        }
                        height={35}
                        error={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.startDate
                        }
                        errorMessage={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.startDate
                        }
                      />
                      <DateInput
                        heading="End Date"
                        value={row.endDate}
                        minDate={
                          row.startDate ? new Date(row.startDate) : today
                        }
                        onChange={(date) =>
                          handleInjectionChange(
                            modalIndex,
                            rowIndex,
                            "endDate",
                            date,
                          )
                        }
                        height={35}
                        error={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.endDate
                        }
                        errorMessage={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.endDate
                        }
                      />

                      <TimeInput
                        type="startTime"
                        heading="Start Time"
                        value={row.startTime}
                        minTime={minTimeForStartTime(row)}
                        maxTime={
                          row.endTime === "24:00" ? "23:45" : row.endTime
                        }
                        minutesStep={15}
                        rtcButton={true}
                        onChange={(value) =>
                          handleInjectionChange(
                            modalIndex,
                            rowIndex,
                            "startTime",
                            value,
                          )
                        }
                        rtcChecked={row.rtcChecked}
                        disabled={row.rtcChecked}
                        handleRTC={(value) => {
                          const isRTC = value === "24:00";
                          const startDateObj = new Date(row.startDate);
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          startDateObj.setHours(0, 0, 0, 0);

                          if (
                            isRTC &&
                            startDateObj.getTime() === today.getTime()
                          ) {
                            const startDT = parseDateTimeFlexible(
                              row.startDate,
                              "00:00",
                            );
                            const threeHoursLater = new Date(
                              new Date().getTime() + 3 * 60 * 60 * 1000,
                            );
                            if (startDT && startDT < threeHoursLater) {
                              setErrors((prevErrors) => {
                                const newErrors = { ...prevErrors };
                                if (!newErrors.injectionModals)
                                  newErrors.injectionModals = [];
                                if (!newErrors.injectionModals[modalIndex])
                                  newErrors.injectionModals[modalIndex] = [];
                                if (
                                  !newErrors.injectionModals[modalIndex][
                                    rowIndex
                                  ]
                                )
                                  newErrors.injectionModals[modalIndex][
                                    rowIndex
                                  ] = {};

                                newErrors.injectionModals[modalIndex][
                                  rowIndex
                                ].startTime =
                                  "Start time must be at least 3 hours ahead when using RTC";

                                return newErrors;
                              });
                              return;
                            }
                          }

                          setErrors((prevErrors) => {
                            const newErrors = { ...prevErrors };
                            if (
                              newErrors.injectionModals?.[modalIndex]?.[
                                rowIndex
                              ]?.startTime
                            ) {
                              delete newErrors.injectionModals[modalIndex][
                                rowIndex
                              ].startTime;
                            }
                            return newErrors;
                          });

                          handleInjectionChange(
                            modalIndex,
                            rowIndex,
                            "rtcChecked",
                            isRTC,
                          );

                          if (isRTC) {
                            handleInjectionChange(
                              modalIndex,
                              rowIndex,
                              "startTime",
                              "00:00",
                            );
                            handleInjectionChange(
                              modalIndex,
                              rowIndex,
                              "endTime",
                              "24:00",
                            );
                          } else {
                            handleInjectionChange(
                              modalIndex,
                              rowIndex,
                              "startTime",
                              "",
                            );
                            handleInjectionChange(
                              modalIndex,
                              rowIndex,
                              "endTime",
                              "",
                            );
                          }
                        }}
                        startTime={row.startTime}
                        startDate={new Date(row.startDate)}
                        height={35}
                        error={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.startTime
                        }
                        errorMessage={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.startTime
                        }
                      />
                      <TimeInput
                        type="endTime"
                        heading="End Time"
                        value={row.endTime}
                        minTime={row.startTime}
                        maxTime="24:00"
                        minutesStep={15}
                        disabled={row.rtcChecked}
                        onChange={(value) =>
                          handleInjectionChange(
                            modalIndex,
                            rowIndex,
                            "endTime",
                            value,
                          )
                        }
                        height={35}
                        error={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.endTime
                        }
                        errorMessage={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.endTime
                        }
                      />
                      <TextInput
                        heading="Quantity (MW)"
                        value={row.quantity}
                        example={"e.g. 100"}
                        onChange={(val) => {
                          if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                            handleInjectionChange(
                              modalIndex,
                              rowIndex,
                              "quantity",
                              val,
                            );
                          }
                        }}
                        height={35}
                        error={
                          errors.injectionModals?.[modalIndex]?.[rowIndex]
                            ?.quantity
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {drawalModals.map((rows, modalIndex) => (
              <div
                key={modalIndex}
                className={`display_flex_column_gap_4 ${Styles.injectDrawalCont}`}
                style={{ position: "relative" }}
              >
                <div className={Styles.draInHeader}>
                  Drawal {drawalModals.length > 1 ? ` ${modalIndex + 1}` : ""}
                </div>

                <div className={Styles.rowsScrollableContainer}>
                  {rows.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
                    >
                      <DateInput
                        heading="Start Date *"
                        value={row.startDate}
                        minDate={today}
                        maxDate={
                          row.endDate ? new Date(row.endDate) : undefined
                        }
                        onChange={(date) =>
                          handleDrawalChange(
                            modalIndex,
                            rowIndex,
                            "startDate",
                            date,
                          )
                        }
                        height={35}
                        error={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]
                            ?.startDate
                        }
                        errorMessage={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]
                            ?.startDate
                        }
                      />
                      <DateInput
                        heading="End Date"
                        value={row.endDate}
                        minDate={
                          row.startDate ? new Date(row.startDate) : today
                        }
                        onChange={(date) =>
                          handleDrawalChange(
                            modalIndex,
                            rowIndex,
                            "endDate",
                            date,
                          )
                        }
                        height={35}
                        error={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]?.endDate
                        }
                        errorMessage={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]?.endDate
                        }
                      />
                      <TimeInput
                        type="startTime"
                        heading="Start Time"
                        value={row.startTime}
                        minTime={minTimeForStartTime(row)}
                        startDate={row.startDate}
                        disabled={row.rtcChecked}
                        maxTime={
                          row.endTime === "24:00" ? "23:45" : row.endTime
                        }
                        rtcButton={true}
                        onChange={(value) =>
                          handleDrawalChange(
                            modalIndex,
                            rowIndex,
                            "startTime",
                            value,
                          )
                        }
                        rtcChecked={row.rtcChecked}
                        handleRTC={(value) => {
                          const isRTC = value === "24:00";

                          handleDrawalChange(
                            modalIndex,
                            rowIndex,
                            "rtcChecked",
                            isRTC,
                          );

                          if (isRTC) {
                            handleDrawalChange(
                              modalIndex,
                              rowIndex,
                              "startTime",
                              "00:00",
                            );
                            handleDrawalChange(
                              modalIndex,
                              rowIndex,
                              "endTime",
                              "24:00",
                            );
                          } else {
                            handleDrawalChange(
                              modalIndex,
                              rowIndex,
                              "startTime",
                              "",
                            );
                            handleDrawalChange(
                              modalIndex,
                              rowIndex,
                              "endTime",
                              "",
                            );
                          }
                        }}
                        height={35}
                        error={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]
                            ?.startTime
                        }
                        errorMessage={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]
                            ?.startTime
                        }
                      />
                      <TimeInput
                        type="endTime"
                        heading="End Time"
                        value={row.endTime}
                        minTime={row.startTime}
                        maxTime="24:00"
                        minutesStep={15}
                        disabled={row.rtcChecked}
                        onChange={(value) =>
                          handleDrawalChange(
                            modalIndex,
                            rowIndex,
                            "endTime",
                            value,
                          )
                        }
                        height={35}
                        error={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]?.endTime
                        }
                        errorMessage={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]?.endTime
                        }
                      />
                      <TextInput
                        heading="Quantity (MW)"
                        value={row.quantity}
                        example={"e.g. 100"}
                        onChange={(val) => {
                          if (/^(\d+(\.\d{0,2})?)?$/.test(val)) {
                            handleDrawalChange(
                              modalIndex,
                              rowIndex,
                              "quantity",
                              val,
                            );
                          }
                        }}
                        height={35}
                        error={
                          errors.drawalModals?.[modalIndex]?.[rowIndex]
                            ?.quantity
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div
              className={`display_flex_row_common ${Styles.eachSelectionMainContainer}`}
              style={{
                gap: "50px",
                alignItems: "flex-start",
                padding: "16px 20px 8px 8px",
              }}
            >
              {/* Quantity Filter */}
              {/* <div className={`display_flex_column_gap_4`} style={{ flex: 1 }}>
                <span className={Styles.filterLabel}>Quantity (MW)</span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 8px",
                    marginBottom: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#f1935c",
                    }}
                  >
                    {quantityRange[0]}
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#f1935c",
                    }}
                  >
                    {quantityRange[1]}
                  </span>
                </div>
                <Box sx={{ width: "100%", padding: "0 8px" }}>
                  <Slider
                    getAriaLabel={() => "Quantity range"}
                    value={quantityRange}
                    onChange={handleQuantityRangeChange}
                    valueLabelDisplay="off"
                    min={0}
                    max={10000}
                    step={100}
                    marks={[
                      { value: 0, label: "0" },
                      { value: 10000, label: "Max" },
                    ]}
                    sx={{
                      color: "#f1935c",
                      height: 8,
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#f1935c",
                        height: 20,
                        width: 20,
                        border: "2px solid #fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        "&:hover, &.Mui-focusVisible": {
                          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        },
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#f1935c",
                        height: 8,
                        border: "none",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#e8e8e8",
                        height: 8,
                        opacity: 1,
                      },
                      "& .MuiSlider-mark": {
                        display: "none",
                      },
                      "& .MuiSlider-markLabel": {
                        fontSize: "11px",
                        color: "#999",
                        fontWeight: "400",
                        top: 28,
                      },
                    }}
                  />
                </Box>
              </div> */}

              {/* Settlement Rate Filter */}
              <div className={`display_flex_column_gap_4`} style={{ flex: 1 }}>
                <span className={Styles.filterLabel}>
                  Settlement Rate (₹/kWh)
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 8px",
                    marginBottom: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#f1935c",
                    }}
                  >
                    {settlementRateRange[0] === 0
                      ? "DAM"
                      : settlementRateRange[0] > 0
                        ? `DAM+${settlementRateRange[0]}`
                        : `DAM${settlementRateRange[0]}`}
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#f1935c",
                    }}
                  >
                    {settlementRateRange[1] === 0
                      ? "DAM"
                      : settlementRateRange[1] > 0
                        ? `DAM+${settlementRateRange[1]}`
                        : `DAM${settlementRateRange[1]}`}
                  </span>
                </div>
                <Box sx={{ width: "100%", padding: "0 8px" }}>
                  <Slider
                    getAriaLabel={() => "Settlement rate range"}
                    value={settlementRateRange}
                    onChange={handleSettlementRateRangeChange}
                    valueLabelDisplay="off"
                    min={-9}
                    max={9}
                    step={1}
                    marks={[
                      // { value: -9, label: "DAM-9" },
                      { value: 0, label: "DAM" },
                      // { value: 9, label: "DAM+9" },
                    ]}
                    sx={{
                      color: "#f1935c",
                      height: 8,
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#ffffff",
                        height: 18,
                        width: 18,
                        border: "2px solid #f1935c",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        "&:hover, &.Mui-focusVisible": {
                          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        },
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#f1935c",
                        height: 6,
                        border: "none",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#e8e8e8",
                        height: 6,
                        opacity: 1,
                      },
                      "& .MuiSlider-mark": {
                        display: "block",
                        backgroundColor: "#999",
                        width: "2px",
                        height: "2px",
                      },
                      "& .MuiSlider-markLabel": {
                        fontSize: "10px",
                        color: "#666",
                        fontWeight: "500",
                        top: 28,
                      },
                    }}
                  />
                </Box>
              </div>

              {/* Banking Factor Filter */}
              <div className={`display_flex_column_gap_4`} style={{ flex: 1 }}>
                <span className={Styles.filterLabel}>Banking Factor (%)</span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "0 8px",
                    marginBottom: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#f1935c",
                    }}
                  >
                    {bankingFactorRange[0]}
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#f1935c",
                    }}
                  >
                    {bankingFactorRange[1]}
                  </span>
                </div>
                <Box sx={{ width: "100%", padding: "0 8px" }}>
                  <Slider
                    getAriaLabel={() => "Banking factor range"}
                    value={bankingFactorRange}
                    onChange={handleBankingFactorRangeChange}
                    valueLabelDisplay="off"
                    min={100}
                    max={200}
                    step={1}
                    // marks={[
                    //   { value: 100, label: "100" },
                    //   { value: 200, label: "200" },
                    // ]}
                    sx={{
                      color: "#f1935c",
                      height: 8,
                      "& .MuiSlider-thumb": {
                        backgroundColor: "#ffffff",
                        height: 18,
                        width: 18,
                        border: "2px solid #f1935c",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        "&:hover, &.Mui-focusVisible": {
                          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                        },
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: "#f1935c",
                        height: 4,
                        border: "none",
                      },
                      "& .MuiSlider-rail": {
                        backgroundColor: "#e8e8e8",
                        height: 4,
                        opacity: 1,
                      },
                      "& .MuiSlider-mark": {
                        display: "none",
                      },
                      "& .MuiSlider-markLabel": {
                        fontSize: "11px",
                        color: "#999",
                        fontWeight: "400",
                        top: 28,
                      },
                    }}
                  />
                </Box>
              </div>

              {/* Credit Rating Filter */}
              <div className={`display_flex_column_gap_4`} style={{ flex: 1 }}>
                {/* <TextInput
                  heading="Credit Rating"
                  value={selectedCreditRating}
                  onChange={handleCreditRatingChange}
                  example="e.g. AA+"
                  height={40}
                  gap={16}
                /> */}
                {renderSelectInput(
                  "rating",
                  "Credit Rating",
                  publicData?.publicRating,
                  "Eg. Select Credit Rating",
                )}
              </div>
            </div>
          </div>
          <div className={`display_flex_row_center ${Styles.filterBtnSection}`}>
            <div
              className={`display_flex_row_center`}
              onClick={resetFilters}
              style={{ cursor: "pointer" }}
            >
              Reset
            </div>
            <div
              className={`display_flex_row_center`}
              onClick={applyFilters}
              style={{ cursor: "pointer" }}
            >
              Apply
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterModal;
